<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-start items-center">
    <div class="grid-toolbar-buttons-group-container">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button"
                  particleAnalytics
                  analyticsCategory="task-manager-board"
                  analyticsAction="add task"
                  (click)="navigateToImportEntities()">Import Entities
          </button>
          <div class="toolbar-separator"></div>
        </div>

        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button"
                  particleAnalytics
                  analyticsCategory="task-manager-board"
                  analyticsAction="add task"
                  (click)="resetEntitiesFromProjectSettings()">Reset Entities from Project Settings
          </button>
          <div class="toolbar-separator"></div>
        </div>
      </div>
    </div>
  </div>
  <mat-sidenav-container>
    <!-- CENTER -->
    <div class="center">
      <!-- CONTENT CARD -->
      <div class="content-card mat-white-bg">
        <!-- CONTENT -->
        <div class="content ps flex flex-col">
          <div class=" p-l-30 p-r-30 p-t-12 p-b-10 flex-1-0-auto">
            <div class="flex flex-row flex-1-1-486px">
              <particle-tree-selector
                [isParentNodeCollapsible]="isParentNodeCollapsible$"
                [tabs]="countryFilterTabs"
                [title]="countryFilterTitle"
                [treeData]="countrySelectorData$"
                [itemViewerName]="itemViewerName"
                [quickSelections]="countryQuickSelections$"
                (selectionChanged)="onCountrySelectionChanged($event)"
                (quickSelectionClicked)="onCountryQuickSelectionClick($event)"
                (onTabChanged)="onTabChanged($event)"></particle-tree-selector>
            </div>
          </div>
        </div>
        <!-- / CONTENT -->
      </div>
      <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
  </mat-sidenav-container>
</div>
